import { render, staticRenderFns } from "./ToolStd.vue?vue&type=template&id=127a53f4&scoped=true"
import script from "./ToolStd.vue?vue&type=script&setup=true&lang=ts"
export * from "./ToolStd.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ToolStd.vue?vue&type=style&index=0&id=127a53f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127a53f4",
  null
  
)

export default component.exports